import Index from "./index.vue"

export default [
  {
    path: "stripeExpress",
    name: "stripe-express",
    component: Index,
    title: "Stripe Express",
  },
]
